



import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import * as models from "@/api/models";
import * as api from "@/api";
@Component({})
export default class DutyUnit extends Vue {
  @Prop() dutyUnitCode: string;
  dutyUnitArr: any = [];
  dutyUnitName: string = "";
  @Watch("dutyUnitCode", { immediate: true })
  async getDutyUnitName(val: string) {
    this.getDutyUnit();
  }
  async getDutyUnit() {
    const data: any = await api.Yq.getAllStandardItems_GET({ key: "dutyUnit" });
    this.dutyUnitArr = data.data;
    this.dutyUnitArr.filter((item: any) => {
      if (item.Value == this.dutyUnitCode) {
        this.dutyUnitName = item.Text;
      }
    });
  }
}
